// Normaliza um documento (CPF/CNPJ) "sujo" removendo qualquer caractere que
// não seja letra ou dígito (pontuação, espaços colados de um paste, etc.) e
// colocando em maiúsculas. Mantém as letras porque o CNPJ alfanumérico usa
// letras nos 12 primeiros caracteres — só remover `.`/`-`/`/` deixa passar
// espaços e outros separadores, quebrando a checagem de tamanho (11/14) feita
// por quem chama esta função. Compartilhada por `formatarCnpj`/
// `formatarDocumento` (format.js), `documentValidator` (functions.js),
// `manifestacaoPertenceEmpresa` (manifestacaoSituacao.js) para evitar
// reimplementar a mesma regex em cada lugar.
//
// Este módulo não tem nenhuma dependência externa de propósito: alguns dos
// pontos acima (ex. manifestacaoSituacao.js) são exercitados por specs e2e
// que fazem `require()` direto do arquivo fonte, fora do bundle webpack. Se
// esta função morasse em `format.js`, que importa `@fnando/cnpj` (cujo
// `package.json` aponta `main` para um build ESM `.mjs`), esse `require()`
// puro quebraria fora do webpack — daí ela viver isolada aqui.
// eslint-disable-next-line import/prefer-default-export
export function normalizarDocumento(valor) {
  return String(valor || '')
    .replace(/[^A-Za-z0-9]/g, '')
    .toUpperCase();
}
